export const AppLink = {
  webSite: {
    label: 'Boom.meme',
    link: 'https://boom.meme/',
  },
  X: {
    label: 'Boom.meme',
    link: 'https://boom.meme/',
  },
  Telegram: {
    label: '@BoomMeme',
    link: 'https://t.me/boompro_official',
  },
};

export const SOL_TOKEN_ADDRESS = 'So11111111111111111111111111111111111111112';

export const APP_NONCE = '[Boom] Please sign to let us verify that you are the owner of this address';
